import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Modal,
  Accordion,
  Image,
} from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./investor.css";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";

// Framer Motion Variants
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};
const scaleUp = {
  hidden: { scale: 0.8, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { duration: 0.7 } },
};

const Investor = () => {
  const [showPayment, setShowPayment] = useState(false);
  const handleProceed = () => setShowPayment(true);
  const handleClose = () => setShowPayment(false);

  return (
    <div>
      {/* header */}
      <Header />

      <div className="investor-main">
        <Container>
          {/* Hero Section */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h1 className="invest-title">Become an Investor</h1>
            <p className="invest-subtitle">
              Minimum investment: <b>₹100,000</b>. Fill the form below and
              proceed to payment to join our mission.
            </p>
            <motion.div whileHover={{ scale: 1.05 }}>
              <Image
                src="./images/in-m-1.jpg"
                fluid
                rounded
                className="hero-image"
              />
            </motion.div>
          </motion.div>

          {/* Why Invest Section */}
          <Row className="mt-5">
            <Col lg={6} md={12}>
              <motion.div
                variants={scaleUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <Card className="invest-card hover-card">
                  <Card.Body>
                    <h4>Why Invest With Us?</h4>
                    <ul>
                      <li>
                        <Image
                          src="/images/benefit1.png"
                          roundedCircle
                          width={30}
                          className="me-2"
                        />
                        High-growth startup
                      </li>
                      <li>
                        <Image
                          src="/images/benefit2.png"
                          roundedCircle
                          width={30}
                          className="me-2"
                        />
                        Transparent reports
                      </li>
                      <li>
                        <Image
                          src="/images/benefit3.png"
                          roundedCircle
                          width={30}
                          className="me-2"
                        />
                        Exclusive investor dashboard
                      </li>
                      <li>
                        <Image
                          src="/images/benefit4.png"
                          roundedCircle
                          width={30}
                          className="me-2"
                        />
                        Profit-sharing opportunities
                      </li>
                      <li>
                        <Image
                          src="/images/benefit5.png"
                          roundedCircle
                          width={30}
                          className="me-2"
                        />
                        Future expansion roadmap
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>

            {/* Investment Form */}
            <Col lg={6} md={12}>
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <Card className="invest-form hover-card">
                  <Card.Body>
                    <h4>Investor Information</h4>
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter full name"
                          required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="yourname@gmail.com"
                          required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Investment Amount (₹)</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Minimum ₹100,000"
                          min={100000}
                          required
                        />
                      </Form.Group>
                      <Button className="pay-btn" onClick={handleProceed}>
                        Proceed to Payment
                      </Button>
                    </Form>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          </Row>

          {/* Founder / Mission Section */}
          <motion.div
            className="mt-5"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Founder & Mission</h2>
            <Row className="align-items-center">
              <Col lg={6} md={12}>
                <motion.div whileHover={{ scale: 1.05 }}>
                  <Image
                    src="/images/m-1.jpg"
                    roundedCircle
                    fluid
                    className="founder-image"
                  />
                </motion.div>
              </Col>
              <Col lg={6} md={12}>
                <Card className="info-card hover-card">
                  <Card.Body>
                    <h5>Founder</h5>
                    <p>
                      John Doe, 10+ years in scaling startups and tech
                      innovation.
                    </p>
                    <h5>Mission</h5>
                    <p>
                      We provide high growth investment opportunities with
                      transparency and trust.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </motion.div>

          {/* Roadmap Section */}
          <motion.div
            className="mt-5"
            variants={scaleUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h2 className="section-title">Growth Roadmap</h2>
            <Row>
              <Col md={3} xs={6}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="roadmap-card"
                >
                  <Image src="/images/in-1.jpg" fluid />
                  <p>2024 Q1 – Product Launch</p>
                </motion.div>
              </Col>
              <Col md={3} xs={6}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="roadmap-card"
                >
                  <Image src="/images/in-2.jpg" fluid />
                  <p>2024 Q2 – Market Expansion</p>
                </motion.div>
              </Col>
              <Col md={3} xs={6}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="roadmap-card"
                >
                  <Image src="/images/in-1.jpg" fluid />
                  <p>2024 Q3 – 1000+ Investors</p>
                </motion.div>
              </Col>
              <Col md={3} xs={6}>
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  className="roadmap-card"
                >
                  <Image src="/images/in-2.jpg" fluid />
                  <p>2024 Q4 – Profit Sharing</p>
                </motion.div>
              </Col>
            </Row>
          </motion.div>

          {/* FAQs Section */}
          <motion.div
            className="mt-5"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h2 className="section-title">Investor FAQs</h2>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Minimum Investment?</Accordion.Header>
                <Accordion.Body>
                  ₹100,000 is the minimum investment required.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>How to proceed to payment?</Accordion.Header>
                <Accordion.Body>
                  Fill the form above and click "Proceed to Payment".
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Can I invest multiple times?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, investors can invest multiple times.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </motion.div>

          {/* Payment Modal */}
          <Modal show={showPayment} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Secure Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Investment Amount: ₹100,000</p>
              <p>Payment Method: Secure Online Gateway</p>
              <Button
                className="payment-btn w-100"
                onClick={() => alert("Redirect to payment gateway")}
              >
                Pay Now
              </Button>
            </Modal.Body>
          </Modal>
        </Container>
        {/* footer */}
        <Footer />
      </div>
    </div>
  );
};

export default Investor;
